<script>
import VueSwiper from "./VueSwiper.vue";
import eventBus from "./EventBus.vue";

export default {
  name: 'modalSertificate',
  data: function () {
    return {
    }
  },
  props: {
    item: {
      type: Object,
      default: function (){
        return {}
      }
    }
  },
  methods: {
    close(event) {
      this.$emit('close', event);
    },
  },
  computed: {
    certificates() {
      let result = [];
      if (this.item.certificates.length > 0) {
        this.item.certificates.forEach(function (item) {
          result.push('/upload/cert/' + item);
        });
      }

      return result;
    }
  },
  components: {
    VueSwiper
  }
};
</script>
<template>
  <transition name="modal">
    <div class="modal-mask" v-if="item.name">
      <div class="modal-wrapper" @click="close($event)">
        <div class="modal-container">
          <div class="modal-header">

            <h3>Сертификаты</h3>
            <button type="button" class="btn-close-modal" @click="close()">×</button>
          </div>

          <div class="modal-body">
            <div class="sertificates" v-if="certificates">
              <vue-swiper :images="certificates" :key="item.id" :item-id="item.id"></vue-swiper>
            </div>
          </div>

          <div class="modal-footer">
            <a class="modal-default-button" @click="close()">
              Закрыть
            </a>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<style scoped>
.modal-container {
  width: 70%;
}
</style>